// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Callout = require("../../common/Components/Callout.bs.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");

function PropertyWizardRelay__PriceDropCallout(props) {
  var onDismiss = props.onDismiss;
  return JsxRuntime.jsx(Callout.Info.make, {
              children: Caml_option.some(JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: "The goal of price reduction broadcasts is to give TAN members advance notice."
                              }),
                          JsxRuntime.jsx(ButtonsV5.OutlineButton.make, {
                                onClick: (function (param) {
                                    onDismiss();
                                  }),
                                size: "small",
                                children: "Got it",
                                color: "TanBlue"
                              })
                        ],
                        className: "flex flex-col gap-6 items-start"
                      })),
              title: "Please ensure the price drop isn't already in the MLS"
            });
}

var make = PropertyWizardRelay__PriceDropCallout;

exports.make = make;
/* Callout Not a pure module */
